module.exports = __webpack_public_path__ + "img/kaifeng.be741ec8.png";